<app-icon [icon]="ICON.LOADING" [spin]="true" *ngIf="loading"></app-icon>

<div *ngIf="!loading && branches?.length > 0" class="branches">
	<h4>Select lender</h4>
	<div class="flex justify-end mb-5">
		<app-button btn="link" size="small" (click)="addNew()"
			>Add new Computershare lender</app-button
		>
	</div>
	<div class="overflow-y-auto">
		<div *ngFor="let branch of branches" class="overflow-y-auto">
			<div
				(click)="setSelectedBranch(branch)"
				class="flex border-b p-2 hover:bg-grey-lighter cursor-pointer"
				[class.bg-green-lightest]="branch.id === selectedBranch?.id"
			>
				{{ branch.name }}
			</div>
		</div>
	</div>

	<div class="flex justify-between mt-10">
		<app-button btn="secondary" (click)="close()" size="small"
			>Close</app-button
		>
		<app-button (click)="select()" size="small" [disabled]="!selectedBranch"
			>Select</app-button
		>
	</div>
</div>

<div *ngIf="error">
	<div>There as an error attempting to load Computershare branches</div>
	<div class="flex justify-between">
		<app-button btn="secondary" (click)="close()" size="small"
			>Close</app-button
		>
		<app-button (click)="fetchBranches()" size="small">Retry</app-button>
	</div>
</div>
